// Puerto de las lecturas multiplanta del proveedor (PP-63, ADR-025): ofertas
// vivas, viajes de un dia, carga por franja y, desde PP-51, posiciones de la
// flota, de todas las plantas donde la
// empresa madre de la cuenta esta habilitada, en un pedido cada una. La vista
// habla con esto y no con fetch: en los tests se reemplaza por un doble y en
// la app por http.ts.
//
// No recibe planta: el conjunto de plantas lo resuelve la API en cada request
// desde la base. El portal igual filtra cada fila contra las habilitaciones
// de la cuenta (logic/home.ts) antes de pintarla.
//
// Las escrituras (aceptar, rechazar, asignar) siguen por planta, con el
// RequestsPort: cada fila trae su `siteId` y `providerId`.
import type {
  ProviderFleetPositionsResponse,
  ProviderMultiSiteOffersResponse,
  ProviderMultiSiteTripsResponse,
  ProviderSlotLoadResponse,
} from "@ucorp/contracts";
import type { PortalSession } from "../auth/session.js";

export interface MultiSitePort {
  /** Ofertas vivas (por responder o por asignar) de cualquier dia operativo. */
  offers(session: PortalSession): Promise<ProviderMultiSiteOffersResponse>;
  /** Viajes de un dia operativo; sin `date`, el de hoy de cada planta en su zona. */
  trips(session: PortalSession, date?: string): Promise<ProviderMultiSiteTripsResponse>;
  /** Carga por franja de hoy (de cada planta), en franjas de 30 minutos. */
  slotLoad(session: PortalSession): Promise<ProviderSlotLoadResponse>;
  /** Posiciones vigentes de la flota, una por vehiculo, con su viaje vigente (PP-51). */
  fleetPositions(session: PortalSession): Promise<ProviderFleetPositionsResponse>;
}

/**
 * Por que fallo una lectura, sin el cuerpo remoto: la UI elige el copy por
 * este codigo y nunca pinta el `detail` de la API.
 * - access: 401 o 403 (la cuenta no es un operador de proveedor activo).
 * - unavailable: 400, 5xx, red o respuesta que viola el contrato.
 */
export type MultiSiteErrorKind = "access" | "unavailable";

export class MultiSiteError extends Error {
  constructor(readonly kind: MultiSiteErrorKind) {
    super(`multi_site_${kind}`);
  }
}
